import { render } from "./heroSlider.vue?vue&type=template&id=5e96976b"
import script from "./heroSlider.vue?vue&type=script&lang=js"
export * from "./heroSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__